var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.783,
    height: 13.178,
    viewBox: "0 0 24.783 13.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-485.159,1215.332a20.3,20.3,0,0,0,4.056-1.886,26.443,26.443,0,0,1,2.658-1.375c.291-.152.556-.354.84-.521.724-.424,1.445-.856,2.185-1.251a4.98,4.98,0,0,1,.822-.236,6.484,6.484,0,0,0,1.366-.814,19.508,19.508,0,0,1,2.275-1.068,25.187,25.187,0,0,0,2.795-1.282,15.252,15.252,0,0,1,1.821-.788,11.069,11.069,0,0,1,2.26-.61c.306-.067.637-.057.8.284a1.3,1.3,0,0,1-.217,1.222c-.845.5-1.738.933-2.544,1.49-1.044.722-2.32.984-3.315,1.821a10.38,10.38,0,0,1-1.954,1c-.4.206-.766.464-1.158.677-.962.522-1.937,1.021-2.9,1.548q-1.472.809-2.922,1.657c-.632.37-1.229.8-1.87,1.157s-1.3.634-1.953.944c-.712.338-1.455.624-2.129,1.025a2.484,2.484,0,0,1-1.376.324c-.088,0-.177-.027-.265-.026a1.536,1.536,0,0,1-1.521-.96,9.638,9.638,0,0,1-.574-2.622,1.128,1.128,0,0,1,.66-1.126c.084-.043.128-.163.211-.209s.265-.1.3-.066C-486.294,1214.22-485.417,1214.439-485.159,1215.332Z",
    transform: "translate(488.002 -1205.469)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick7);
export default __webpack_public_path__ + "static/media/tick-7.091a8b1aec18c2d197d5c25937346e1d.svg";
export { ForwardRef as ReactComponent };